import moment from 'moment';
import { DATE_PICKER_DATE_FORMAT } from "../settings";

//getDatesBetween - to get the dates in between start and end dates
export const getDatesBetween = (startDate, endDate) => {
    const dates = [];
    // Strip hours minutes seconds etc.
    let currentDate = new Date(
        startDate.getFullYear(),
        startDate.getMonth(),
        startDate.getDate()
    );
    while (currentDate <= endDate) {
        dates.push(moment(currentDate).format(DATE_PICKER_DATE_FORMAT));

        currentDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate() + 1, // Will increase month if over range
        );
    }
    return dates;
};